import {
  INFLUENCER_SAVE_SUCCESS,
  INFLUENCER_SAVE_FAILURE,
  RELEVANT_INFLUENCER_LOAD_SUCCESS,
  RELEVANT_INFLUENCER_LOAD_FAILURE
} from '../constants';
import { findDOMNode } from 'react-dom';

export const saveProfile = influencerData => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();

    firebase
      .updateProfile({ ...influencerData })
      .then(() => {
        dispatch({
          type: INFLUENCER_SAVE_SUCCESS,
          payload: { influencerData }
        });
        saveInfluencerInterests(firestore, influencerData.interests);
      })
      .catch(err => {
        dispatch({ type: INFLUENCER_SAVE_FAILURE, err });
      });
  };
};

const saveInfluencerInterests = (firestore, interests) => {
  if (interests && interests.length) {
    firestore
      .collection('tags')
      .doc('influencer')
      .get()
      .then(interestDoc => {
        if (interestDoc.exists) {
          interests.map(interest => {
            interestDoc.ref.update({
              interests: firestore.FieldValue.arrayUnion(interest)
            });
          });
        } else {
          firestore
            .collection('tags')
            .doc('influencer')
            .set({
              interests
            });
        }
      });
  }
};

export const updateProfile = influencerData => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    firebase
      .updateProfile({ ...influencerData })
      .then(() => {
        dispatch({
          type: INFLUENCER_SAVE_SUCCESS,
          payload: { influencerData }
        });
        saveInfluencerInterests(firestore, influencerData.interests);
      })
      .catch(err => {
        dispatch({ type: INFLUENCER_SAVE_FAILURE, err });
      });
  };
};

export const saveProfilePictureUrl = profilePictureUrl => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    firebase
      .updateProfile({ profilePictureUrl })
      .then(() => {
        dispatch({
          type: INFLUENCER_SAVE_SUCCESS,
          payload: { profilePictureUrl }
        });
      })
      .catch(err => {
        dispatch({ type: INFLUENCER_SAVE_FAILURE, err });
      });
  };
};

export const loadRelevantInfluencers = () => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('users')
      .orderBy('youtube.subscribers', 'desc')
      .where('status', '==', 'ACTIVE')
      .where('isCompany', '==', false)
      .limit(5)
      .get()
      .then(influencerSnapshots => {
        if (influencerSnapshots) {
          const influencers = influencerSnapshots.docs.map(snapshot => {
            return {
              ...snapshot.data(),
              id: snapshot.id
            };
          });
          dispatch({
            type: RELEVANT_INFLUENCER_LOAD_SUCCESS,
            payload: { influencers }
          });
        }
      })
      .catch(err => {
        dispatch({
          type: RELEVANT_INFLUENCER_LOAD_FAILURE,
          payload: { err }
        });
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/influencerActions.js